export default __webpack_public_path__ + "static/media/smallColoredLogoConcorrencia.5e30262a.svg";